import { App } from './interfaces'

export function getAgentDescription(app: App) {
  if (app?.description) {
    let description
    try {
      description = JSON.parse(app.description)
      return description.agentDescription
    } catch {
      return app.description
    }
  }
}

export function getAgentInstructions(app: App) {
  if (app?.description) {
    try {
      const description = JSON.parse(app.description)
      return description.agentInstructions
    } catch {}
  }
}
